import {
  ArrowUpRight,
  BookHeadphones,
  ChartNoAxesCombined,
  Coins,
  Gem,
  Handshake,
  Headset,
  Palette,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function ExploreRoles() {
  const roles = [
    {
      icon: <Palette className="ml-auto w-8 h-8 role-icon" />,
      name: "Creative & Production",
      available: 6,
    },
    {
      icon: <ChartNoAxesCombined className="ml-auto w-8 h-8 role-icon" />,
      name: "Growth & Strategy",
      available: 4,
    },
    {
      icon: <Handshake className="ml-auto w-8 h-8 role-icon" />,
      name: "Communications & Collaboration",
      available: 4,
    },
    {
      icon: <BookHeadphones className="ml-auto w-8 h-8 role-icon" />,
      name: "Research & Support",
      available: 2,
    },
    {
      icon: <Coins className="ml-auto w-8 h-8 role-icon" />,
      name: "Monetization & Business",
      available: 2,
    },
    {
      icon: <Gem className="ml-auto w-8 h-8 role-icon" />,
      name: "Specialized & High-Value Roles",
      available: 2,
    },
    {
      icon: <Headset className="ml-auto w-8 h-8 role-icon" />,
      name: "Technical & Platform Support",
      available: 2,
    },
    {
      icon: <ArrowUpRight className="ml-auto w-8 h-8 role-icon" />,
      name: "Read more",
      available: 32,
    },
  ];

  return (
    <div
      id="explore-roles"
      className="lg:py-10 w-[85%] md:w-[70%] mx-auto space-y-12 md:space-y-20 4xl:max-w-[100rem]"
    >
      <div className="space-y-4 text-center">
        <h1 className="text-4xl md:text-5xl text-primaryLight">
          Explore Roles
        </h1>
        <p className="text-[#EDE9FE] max-w-3xl mx-auto text-sm md:text-lg">
          From creative talent to business experts, EnfiniTask connects you with
          the right professionals who power growth, scale operations, and
          protect your brand.
        </p>
      </div>
      <div className="flex overflow-x-auto gap-4 px-4 md:grid md:grid-cols-2 lg:grid-cols-3 1xl:grid-cols-4 md:gap-8 md:px-0 scrollbar-hide">
        {roles.map((role, index) => (
          <Link
            key={index}
            to={`/talent-hub/${encodeURIComponent(
              index !== 7 ? role.name : ""
            )}`}
            className="block flex-shrink-0 w-64 md:w-auto"
          >
            <div
              className={`${
                index !== 7
                  ? "bg-[#161616] hover:bg-primary hover:text-white"
                  : "bg-[linear-gradient(225deg,#2F2F2F,#161616)] hover:!bg-primary hover:!text-white"
              } border border-[#434242] rounded-[20px] p-5 text-primaryLight flex flex-col gap-8 justify-between w-full h-full role-card`}
            >
              {role.icon}
              <div className="space-y-2 role-text">
                <h1 className="text-2xl">{role.name}</h1>
                <p className="text-[#EDE9FE] text-sm">
                  +{role.available} roles available
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
